import * as Icons from "@phosphor-icons/react";
import ActionCellContent from "nlib/common/ActionCellContent";
import React, { useCallback, useMemo } from "react";

const Component = ({ disabled, id, onPreview }) => {
  const menuItems = useMemo(() => {
    return [
      {
        action: "preview",
        icon: disabled ? Icons.EyeSlash : Icons.Eye,
        theme: disabled ? "medium" : "primary"
      }
    ].filter(Boolean);
  }, [disabled]);

  const handleActionClick = useCallback((action) => {
    switch (action) {
      case "preview": onPreview(id);
        break;

      default:
        break;
    }
  }, [id, onPreview]);

  return (
    <ActionCellContent
      disabled={disabled}
      menuItems={menuItems}
      onClick={handleActionClick} />
  );
};

export default React.memo(Component);
